// Income  State

export default {
  incomeList: [],
  incomeInfo: {}
}
